<template>
  <div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.LOGIN">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> logged in at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.SING_UP">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> just signed up at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.WORKOUT_CREATED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> created a new workout at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div
      class="item-row"
      v-if="item.eventType === EVENT_TYPES.WORKOUT_SHARED_BY_USER"
    >
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> shared a BYO at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.WORKOUT_STARTED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      started a
      <span
        v-if="openWorkoutModal && item.type !== 'Freestyle'"
        @click="handleWorkoutClick(item)"
        class="user-link"
        >{{ getWorkoutName(item) }}</span
      >
      <span v-else>{{ getWorkoutName(item) }}</span> at {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.WORKOUT_PAUSED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      paused a
      <span
        v-if="openWorkoutModal && item.type !== 'Freestyle'"
        @click="handleWorkoutClick(item)"
        class="user-link"
        >{{ getWorkoutName(item) }}</span
      >
      <span v-else>{{ getWorkoutName(item) }}</span> at {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.WORKOUT_RESUMED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      resumed a
      <span
        v-if="openWorkoutModal && item.type !== 'Freestyle'"
        @click="handleWorkoutClick(item)"
        class="user-link"
        >{{ getWorkoutName(item) }}</span
      >
      <span v-else>{{ getWorkoutName(item) }}</span> at {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div
      class="item-row"
      v-if="item.eventType === EVENT_TYPES.WORKOUT_COMPLETED"
    >
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      completed a
      <span
        v-if="openResultModal"
        @click="openResultModal(item)"
        class="user-link"
        >{{ getWorkoutName(item) }}</span
      >
      <span v-else>{{ getWorkoutName(item) }}</span>
      at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.POST_CREATED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      created a
      <span v-if="openPostModal" @click="openPostModal(item)" class="user-link"
        >post</span
      >
      <span v-else>post</span> at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.POST_SHARED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      shared a
      <span v-if="openPostModal" @click="openPostModal(item)" class="user-link"
        >post</span
      >
      <span v-else>post</span> at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.POST_COMMENT">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      commented a
      <span v-if="openPostModal" @click="openPostModal(item)" class="user-link"
        >post</span
      >
      <span v-else>post</span> at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.POST_PUMP">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      pumped a
      <span v-if="openPostModal" @click="openPostModal(item)" class="user-link"
        >post</span
      >
      <span v-else>post</span> at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div
      class="item-row"
      v-if="item.eventType === EVENT_TYPES.SUBSCRIPTION_CREATED"
    >
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> got a subscription at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.PROGRAM_JOIN">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> joined a program at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div
      class="item-row"
      v-if="item.eventType === EVENT_TYPES.PROGRAM_COMPLETED"
    >
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> completed a program at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div
      class="item-row"
      v-if="item.eventType === EVENT_TYPES.IAChat_MESSAGE_SENT"
    >
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> asked to AI: "{{
        item.message
      }}" at
      {{ getEventDate(item) }}
      <span v-if="item.success === false"
        >with
        <span @click="openErrorModal(item)" class="user-link">Error</span></span
      >
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.APP_OPENED">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span> opened the app at
      {{ getEventDate(item) }}
    </div>
    <div class="item-row" v-if="item.eventType === EVENT_TYPES.ACTIVE_USERS">
      <span
        class="user-link"
        @click="handleUserPress(item.user)"
        v-if="openUserModal"
        >{{ getUserName(item) }}</span
      >
      <span v-else>{{ getUserName(item) }}</span>
      <span v-if="item.user.lastLogin">
        (Last login: {{ getUserLastLogin(item) }})
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { EVENT_TYPES } from "@/constants/eventTypes";

export default {
  name: "event-row",
  model: {},
  props: {
    item: undefined,
    openErrorModal: undefined,
    openPostModal: undefined,
    openResultModal: undefined,
    openUserModal: undefined,
    openWorkoutModal: undefined,
  },
  data() {
    return {
      EVENT_TYPES,
    };
  },
  created() {},
  methods: {
    getUserLastLogin(item) {
      return item.user.lastLogin ? moment(item.user.lastLogin).format("ddd MMM DD YYYY HH:mm") : "N/A";
    },
    getUserName(item) {
      const user = item.user;
      if (user.nickname && user.nickname !== "") {
        return user.nickname;
      }
      if (user.displayName && user.displayName !== "") {
        return user.displayName;
      }

      if (
        item.eventType === EVENT_TYPES.LOGIN ||
        item.eventType === EVENT_TYPES.SING_UP
      ) {
        if (user.email && user.email !== "") {
          return user.email;
        }
      }

      return `${user.firstName} ${user.lastName}`;
    },
    getWorkoutName(item) {
      // return item.type
      switch (item.type) {
        case "coachedClass":
          return "Coached Class";
        case "live":
          return "Live";
        case "byo":
          return "BYO";
        case "Freestyle":
          return "FreeStyle";
        case "preSet":
          return "Pre Set";
        default:
          return "workout";
      }
    },
    getEventDate(item) {
      return moment(item.createdAt.toDate()).format("ddd MMM DD YYYY HH:mm");
    },
    changeRouteUser(item) {
      let vm = this;
      vm.$router.push({ name: "User Profile", params: item.user });
    },
    handleUserPress(user) {
      if (!user) {
        console.warn("Attempted to open user preview with null user data");
        return;
      }
      if (this.openUserModal) {
        this.openUserModal(user);
      }
    },
    handleWorkoutClick(item) {
      if (item.type === "Freestyle") {
        return;
      }
      if (this.openWorkoutModal) {
        this.openWorkoutModal(item.workoutId, item.type, item.user.id);
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
.item-row {
  font-size: 16px;
}

.user-link {
  color: #ed702d;
  font-weight: bold;
}

.user-link:hover {
  cursor: pointer;
}
</style>
